import { render, staticRenderFns } from "./ParentExpand.vue?vue&type=template&id=2e52a9ff&scoped=true&"
import script from "./ParentExpand.vue?vue&type=script&lang=js&"
export * from "./ParentExpand.vue?vue&type=script&lang=js&"
import style0 from "./ParentExpand.vue?vue&type=style&index=0&id=2e52a9ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52a9ff",
  null
  
)

export default component.exports